{
  "#SEND_NOTIFICATION": {
    "APP": "Send Notification",
    "TITLE": "Send Notification",
    "NEXT": "Next",
    "EMPFAENGER_AUSWAEHLEN": "Select Recipient(s)",
    "EMPFAENGER_AUSWAEHLEN_DESC": "Please select one or more recipients",
    "NACHRICHT_VERFASSEN": "Compose Message",
    "NACHRICHT_VERFASSEN_DESC": "Please enter a subject and message",
    "NACHRICHT_SENDEN": "Send Message"
  }
}
